module.exports = __webpack_public_path__ + "img/justify.ec58e084.svg";